var _a;
var RewardsClients;
(function (RewardsClients) {
    RewardsClients["aeoutfitters"] = "aeoutfitters";
    RewardsClients["athome"] = "athome";
    RewardsClients["cathay"] = "cathay";
    RewardsClients["dicks"] = "dicks";
    RewardsClients["hft"] = "hft";
    RewardsClients["jcpenney"] = "jcpenney";
    RewardsClients["jcrew"] = "jcrew";
    RewardsClients["onepaywalmart"] = "onepaywalmart";
    RewardsClients["suncountry"] = "suncountry";
    RewardsClients["tjx"] = "tjx";
    RewardsClients["verizon"] = "verizon";
    RewardsClients["virgin"] = "virgin";
    RewardsClients["walgreens"] = "walgreens";
})(RewardsClients || (RewardsClients = {}));
export var OwnRewardsClients;
(function (OwnRewardsClients) {
    OwnRewardsClients["aeoutfitters"] = "aeoutfitters";
    OwnRewardsClients["dicks"] = "dicks";
    OwnRewardsClients["jcpenney"] = "jcpenney";
    OwnRewardsClients["onepaywalmart"] = "onepaywalmart";
})(OwnRewardsClients || (OwnRewardsClients = {}));
export var CLIENTS_DATA = (_a = {},
    _a[RewardsClients.athome] = {
        certificateValue: 5,
        certificateExpirationDays: 90
    },
    _a[RewardsClients.hft] = {
        certificateValue: 5,
        certificateExpirationDays: 30
    },
    _a[RewardsClients.tjx] = {
        certificateValue: 10,
        certificateExpirationDays: 90
    },
    _a);
export default RewardsClients;
